<template>
	<div :class="{[$style.footer]: true,[$style.footerFullWidth]: settings.isContentNoMaxWidth}">
		<div :class="$style.inner">
			<div class="row align-items-center">
				<div class="col-md-8">
					<p><strong>MiChollo - Panel de Control</strong></p>
					<p>© {{ $moment(new Date()).format('YYYY') }} HREF DIGITAL S.L. Todos los derechos reservados.</p>
				</div>
				<div class="col-md-4 d-flex justify-content-end">
					<logo />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex';

export default {
	computed: mapState(['settings']),
};
</script>

<style lang="scss" module>
	@import "./style.module.scss";
</style>
